export const textAndIconCardGql = /* GraphQL */ `
... on landingPageContent_textIconCardsV2_BlockType {
  id
  typeHandle
  componentTheme:textIconCardLPComponentTheme
  cardStyle:textIconCardLPCardStyle
  alignCenter
  cards:textIconCardLP {
    ... on textIconCardLP_BlockType {
      cardDescription
      cardSubtitle
      cardTitle
      icon {
        ... on svgIcons_Asset {
          url
          title
        }
      }
      cardTheme:textIconCardLPCardTheme
      cardLink {
        ariaLabel
        customText
        url
        target
      }
    }
  }
}`;
